import axios from 'axios';
import { getSessionCookie, setSessionCookie } from 'helpers/cookies';

const urlApi = process.env.REACT_APP_API_ENDPOINT 
const tenantId = window.location.host.split(':')[0].split('.')[0];

const api_POST = (endpoint, obj) => {

  const promise = new Promise((resolve, reject) => {

    var token = getSessionCookie();
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now) {
      token.expired = true;
      setSessionCookie(token)
      window.location.reload();
      resolve(null);
    }

    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId, 'Authorization': `Bearer ${token.token}` } };
      return axios.post(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setSessionCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }

            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_POST_Unauthorize = (endpoint, obj) => {

  const promise = new Promise((resolve, reject) => {

    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId } };
      return axios.post(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {          
          if (error.response) {
            var message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }

            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_PUT = (endpoint, obj) => {

  const promise = new Promise((resolve, reject) => {

    var token = getSessionCookie();
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now) {
      token.expired = true;
      setSessionCookie(token)
      window.location.reload();
      resolve(null);
    }

    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId, 'Authorization': `Bearer ${token.token}` } };
      return axios.put(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setSessionCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }

            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_DELETE = (endpoint, obj) => {

  const promise = new Promise((resolve, reject) => {

    var token = getSessionCookie();
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now) {
      token.expired = true;
      setSessionCookie(token)
      window.location.reload();
      resolve(null);
    }

    try {
      console.log(obj);
      const urlComplete = urlApi + endpoint + "/" + obj;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId, 'Authorization': `Bearer ${token.token}` } };
      return axios.delete(urlComplete, headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setSessionCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_GET = (endpoint) => {

  const promise = new Promise((resolve, reject) => {

    var token = getSessionCookie();
    var now = new Date();
    var expiration = new Date(token.expiration);
    if (expiration < now) {
      token.expired = true;
      setSessionCookie(token)
      window.location.reload();
      resolve(null);
    }

    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Authorization': `Bearer ${token.token}`, 'tenantId': tenantId } };
      return axios.get(urlComplete, headers)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setSessionCookie(token)
              window.location.reload();
              return;
            }

            let message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;

};

const api_GET_Unauthorize = (endpoint) => {
  const promise = new Promise((resolve, reject) => {
    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'tenantId': tenantId } };
      return axios.get(urlComplete, headers)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            let message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;

};

const api_GETExternal = (endpoint) => {

  const promise = new Promise((resolve, reject) => {

    try {
      const urlComplete = endpoint;      
      return axios.get(urlComplete)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,            
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            
            let message = "";
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;

};

export { api_POST, api_POST_Unauthorize, api_PUT, api_DELETE, api_GET, api_GETExternal, api_GET_Unauthorize};